"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_50470f33{display:table-row}.resultContent_50470f33 .resultItem_50470f33{display:table-cell;vertical-align:bottom}.peoplePickerPersona_50470f33{width:180px}.peoplePickerPersona_50470f33 .ms-Persona-details{width:100%}.peoplePicker_50470f33 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_50470f33{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
exports.resultContent = "resultContent_50470f33";
exports.resultItem = "resultItem_50470f33";
exports.peoplePickerPersona = "peoplePickerPersona_50470f33";
exports.peoplePicker = "peoplePicker_50470f33";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_50470f33";
//# sourceMappingURL=ExtendedPeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ExtendedPicker/PeoplePicker/ExtendedPeoplePicker.scss.js
// module id = 977
// module chunks = 0